if (!customElements.get('product-customization-fields')) {
  customElements.define(
    'product-customization-fields',
    class ProductCustomizationFields extends HTMLElement {
      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;

          const updatedFields = event.data.html.querySelector(
            `product-customization-fields[data-section-id="${this.dataset.sectionId}"]`
          );
          if (!updatedFields) return;

          const shouldHide = updatedFields.classList.contains('hidden');
          this.classList.toggle('hidden', shouldHide);
          this.toggleFields(!shouldHide);
        });
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      toggleFields(enabled) {
        this.querySelectorAll('input').forEach((input) => {
          input.disabled = !enabled;
        });
      }
    }
  );
}
